import React, { useState } from 'react';
import { submitFeedback } from '../utils/api';
import { useTheme } from '../context/ThemeContext';

const FeedbackSection = ({ 
  selectedScreen, 
  transducer, 
  battery,
  shuttle,
  pole,
  totalMSRP,
  showHeader = true
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [commentStatus, setCommentStatus] = useState('');
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState(null);
  const { theme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) return;

    try {
      const sessionDetails = {
        selectedScreen,
        selectedTransducer: transducer,
        selectedBattery: battery,
        selectedShuttle: shuttle,
        selectedPole: pole,
        totalMSRP: totalMSRP
      };

      console.log('Session Details:', sessionDetails);

      await submitFeedback(comment, sessionDetails);
      setStatus({
        type: 'success',
        message: 'Thank you for sharing your experience! Alex just got it emailed to him and reviews every one of them!'
      });
      setComment('');
    } catch (error) {
      console.error('Feedback submission error:', error);
      setStatus({
        type: 'error',
        message: 'Failed to submit feedback. Please try again.'
      });
    }
  };

  return (
    <div className="feedback-section" style={{
      background: theme.isDarkMode ? theme.colors.surface : '#d8d8d8',
      borderRadius: '12px',
      padding: '16px',
      marginTop: '24px',
      border: `1px solid ${theme.colors.border}`,
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box'
    }}>
      {showHeader && (
        <>
          <h3 style={{ 
            fontSize: '20px',
            fontWeight: '600',
            marginBottom: '8px',
            color: theme.isDarkMode ? '#fff' : '#333'
          }}>What do you think?</h3>
          <p style={{ 
            fontSize: '15px',
            marginBottom: '12px',
            color: theme.isDarkMode ? '#e0e0e0' : '#555'
          }}>Help others by sharing your thoughts about this tool or your buying experience</p>
        </>
      )}
      <div className="feedback-preview" style={{ width: '100%' }}>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <textarea 
            placeholder="Quick feedback? Let us know how this tool helped you, or what we could improve..."
            className="comment-textarea-preview"
            disabled={commentStatus === 'sending'}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{
              width: '100%',
              minHeight: '100px',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '12px',
              fontSize: '14px',
              backgroundColor: theme.isDarkMode ? '#333' : '#fff',
              color: theme.isDarkMode ? '#fff' : '#333',
              boxSizing: 'border-box',
              resize: 'vertical'
            }}
          ></textarea>
          <div style={{
            display: 'flex',
            gap: '8px',
            flexWrap: 'wrap',
            marginTop: '8px'
          }}>
            <button
              type="submit"
              className="submit-feedback-btn"
              disabled={commentStatus === 'sending'}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                backgroundColor: theme.isDarkMode ? '#4a90e2' : '#2979ff',
                color: '#fff',
                border: 'none',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                flex: '1',
                minWidth: '120px',
                maxWidth: '200px'
              }}
            >
              {commentStatus === 'sending' ? 'Sending...' : 'Share Feedback'}
            </button>
            <button 
              type="button"
              className="see-suggestions-btn"
              onClick={() => setShowSuggestions(!showSuggestions)}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                color: theme.isDarkMode ? '#fff' : '#333',
                border: `1px solid ${theme.isDarkMode ? '#555' : '#ccc'}`,
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                flex: '1',
                minWidth: '120px',
                maxWidth: '200px'
              }}
            >
              {showSuggestions ? 'Hide Suggestions' : 'See Suggestions'}
            </button>
          </div>
        </form>
      </div>
      
      {showSuggestions && (
        <div className="feedback-suggestions" style={{ 
          marginTop: '12px',
          padding: '12px',
          borderRadius: '8px',
          backgroundColor: theme.isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'
        }}>
          <p style={{ 
            fontSize: '14px',
            marginBottom: '8px',
            color: theme.isDarkMode ? '#e0e0e0' : '#555'
          }}>Here are some things you might want to share:</p>
          <ul className="feedback-prompts" style={{ 
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            <li style={{ 
              marginBottom: '6px',
              fontSize: '14px',
              color: theme.isDarkMode ? '#e0e0e0' : '#555'
            }}>💡 Did this tool help you make a decision?</li>
            <li style={{ 
              marginBottom: '6px',
              fontSize: '14px',
              color: theme.isDarkMode ? '#e0e0e0' : '#555'
            }}>💰 Did you find good deals through our links?</li>
            <li style={{ 
              marginBottom: '6px',
              fontSize: '14px',
              color: theme.isDarkMode ? '#e0e0e0' : '#555'
            }}>🎯 What features or brands would you like to see added?</li>
            <li style={{ 
              fontSize: '14px',
              color: theme.isDarkMode ? '#e0e0e0' : '#555'
            }}>⭐ What was the most helpful part?</li>
          </ul>
        </div>
      )}
      
      {status && status.type === 'success' && (
        <p className="success-message" style={{
          marginTop: '12px',
          padding: '10px',
          borderRadius: '6px',
          backgroundColor: '#4caf50',
          color: '#fff',
          fontSize: '14px'
        }}>{status.message}</p>
      )}
      
      {status && status.type === 'error' && (
        <p className="error-message" style={{
          marginTop: '12px',
          padding: '10px',
          borderRadius: '6px',
          backgroundColor: '#f44336',
          color: '#fff',
          fontSize: '14px'
        }}>{status.message}</p>
      )}
    </div>
  );
};

export default FeedbackSection; 